import React, { useEffect, useState } from "react";
import CaseList from "../components/caseList";
import {
  ACCESS_DENIED,
  ADDCASE,
  CASEINCIDENTS,
  CASES,
  EDITCASE,
} from "../../../constant/routeContant";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as incidentAction from "../../../redux/actions/incidentAction";
import { checkPrivileges } from "../../../utils/rolesHelper";
import { API_STATUS } from "../../../constant/constant";
import { ToastContainer, toast } from "react-toastify";
import { InactiveClient } from "../../../utils/helper";
import { getPreviousRoute } from "../../../utils/routeTracker";
const CasesContainer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const createCase = () => {
    if (InactiveClient()) return;
    navigate(ADDCASE);
  };

  const deleteCaseData = useSelector((state) => state.deleteCase);
  const cases = useSelector((state) => state.casesList);
  const isLoading = useSelector(
    (state) => state.casesList?.isLoading || state.deleteCase?.isLoading,
  );
  const [incedentPending, setIncedentPending] = useState(false);
  const [clearMessage, setClearMessage] = useState(false);
  const [sendEmail, setSendEmail] = useState(false);
  const [shouldRestoreState, setShouldRestoreState] = useState(null);

  const defaultData = {
    page: 1,
    search: "",
    date_from: "",
    date_to: "",
    statusIds: "",
    isSendMail: false,
  };

  useEffect(() => {
    const previousRoute = getPreviousRoute();
    const preserveRoutes = [CASES, CASEINCIDENTS, EDITCASE];
    const isFromPreserveRoute =
      previousRoute &&
      preserveRoutes.some((r) => previousRoute.startsWith(r)) &&
      sessionStorage.getItem("caseListPreserveState") === "true";
    sessionStorage.removeItem("caseListPreserveState");

    if (isFromPreserveRoute && cases?.filterObj) {
      setShouldRestoreState(true);
      getCasesListData(cases.filterObj);
    } else {
      setShouldRestoreState(false);
      getCasesListData(defaultData);
    }
  }, []);
  useEffect(() => {
    if (
      deleteCaseData?.status === API_STATUS?.SUCCESS &&
      deleteCaseData?.data?.responseMessages?.responseMessage?.toLowerCase() ===
        "unable to delete the case until all incidents have been deleted" &&
      clearMessage
    ) {
      setIncedentPending(true);
      setClearMessage(false);
    }
    if (
      deleteCaseData?.status === API_STATUS?.SUCCESS &&
      deleteCaseData?.data?.responseMessages?.responseMessage?.toLowerCase() ===
        "request was successful" &&
      clearMessage
    ) {
      toast("Case Deleted successfully");
      setIncedentPending(false);
      setClearMessage(false);
      if (cases?.filterObj) {
        getCasesListData(cases.filterObj);
      } else {
        getCasesListData(defaultData);
      }
    }
  }, [deleteCaseData]);

  const getCasesListData = (data) => {
    if (data?.isSendMail) {
      setSendEmail(true);
    } else {
      setSendEmail(false);
    }
    dispatch(incidentAction.getCasesList(data));
    dispatch(incidentAction.getViewCasesFilterObj(data));
  };

  const handleViewOnClick = (caseId) => {
    sessionStorage.setItem("caseListPreserveState", "true");
    navigate(CASEINCIDENTS, {
      state: { caseId: caseId },
    });
  };

  const handleEditOnClick = (caseId) => {
    if (InactiveClient()) return;
    sessionStorage.setItem("caseListPreserveState", "true");
    navigate(EDITCASE, {
      state: {
        caseId: caseId,
        editMode: true,
        isEditModeThroughViewCase: false,
      },
    });
  };

  const deleteCase = (deleteCase) => {
    setClearMessage(true);
    dispatch(incidentAction.deleteCaseList(deleteCase.caseId));
  };
  useEffect(() => {
    if (cases?.status === API_STATUS.SUCCESS && sendEmail) {
      toast("Case has been sent to registered email ID");
    }
  }, [cases]);


  return (
    <>
      {checkPrivileges([12, 149, 150, 151]) ? (
        <CaseList
          createCase={createCase}
          isFullAccess={checkPrivileges([151, 12])}
          isWriteAccess={checkPrivileges([150, 12])}
          isReadAccess={checkPrivileges([149, 12])}
          casesData={isLoading ? [] : cases?.data}
          isLoading={isLoading}
          getCasesListData={getCasesListData}
          handleViewOnClick={handleViewOnClick}
          handleEditOnClick={handleEditOnClick}
          deleteCase={deleteCase}
          incedentPending={incedentPending}
          setIncedentPending={setIncedentPending}
          casesdata={cases}
          shouldRestoreState={shouldRestoreState}
          deleteCaseData={deleteCaseData}
        />
      ) : (
        navigate(ACCESS_DENIED)
      )}

      <ToastContainer />
    </>
  );
};

export default CasesContainer;
